//defaultState.js
//the return value is the same as that in the state
const defaultState = () => {
    return {
      items: [],
      status: 'empty'
    }
  }
export default defaultState